export default __webpack_public_path__ + "711c1f660b2c8f38aa2a33bd438d1917.png";